import {CONTACT_LIST_SET_GROUP} from "./actionTypes";

export const contactListSetGroup = (group)  => ({
    type: CONTACT_LIST_SET_GROUP,
    payload: {
        group
    }
});